import { Directive, ElementRef, HostListener, Renderer } from '@angular/core';


@Directive({
  selector: '[expand]'
})
export class ExpandHierachyItemDirective {

  constructor(private element: ElementRef, private renderer: Renderer) {
  }

  @HostListener('click')
  onClick() {
    let hiereachyGroup = this.element.nativeElement.parentNode.children[2];
    this.renderer.setElementStyle(hiereachyGroup, 'display', 'block');
  }

}



// WEBPACK FOOTER //
// ./src/directives/expand-hierachy-item/expand-hierachy-item.ts